import styled, { css } from "styled-components";
import { Color, Screen } from 'styles';

const MediumWrapperStyle = css`
  padding-top: 100px;
`;

export const StyledElementWrapper = styled.section`
  background-color: ${prop => prop.white ? Color.White : Color.MediumGray};
  border-bottom: 6px solid ${Color.Black};
  padding-top: 225px;
  width: 100%;
  
  ${Screen.medium(MediumWrapperStyle)}
`;


// WEBPACK FOOTER //
// ./src/utils/styledElements/wrapper/wrapper.style.js